import React from 'react';
import { Section } from '../components/UI';

export const week_2026_01_05 = {
    id: "WK-JAN05",
    date: "Jan 05, 2026",
    title: "Q4 Review & Sales Presentation",
    attendees: "Marlee, Benton",
    summary: "Creating the Q4 Strategy Summary, restarting Content Syndication updates for Q1, and reviewing the Sales/SDR presentation.",
    tags: ["Strategy", "Reporting", "Enablement"],
    deliverables: [
      {
        id: "d1_jan",
        text: "Create Q4 Strategy & Consulting Summary (1-2 Pages)",
        owner: "Ben",
        links: [
          {
            label: "View Summary Outline",
            modalContent: (
               <>
                 <div style={{ marginBottom: "24px" }}>
                  <h1 className="text-heading-lg" style={{ marginBottom: "4px" }}>Q4 Strategy & Consulting Summary</h1>
                  <p className="text-body" style={{ color: "var(--ink-soft)" }}>
                    Executive overview of the $15K strategy/consulting line item work completed in Q4.
                  </p>
                </div>
                <Section index="1" label="Monthly Priorities">
                  <p>Breakdown of focus areas for Oct, Nov, and Dec.</p>
                </Section>
                <Section index="2" label="Execution & Testing">
                  <p>Summary of what was launched (e.g. ABM Pilot, Social Tooling).</p>
                </Section>
                <Section index="3" label="Results & Learnings">
                  <p>Key takeaways and early performance signals.</p>
                </Section>
                <Section index="4" label="Next Steps">
                  <p>Recommended actions for Q1 momentum.</p>
                </Section>
               </>
            ),
          }
        ]
      },
      {
        id: "d2_jan",
        text: "Restart Content Syndication Summary Emails",
        owner: "Ben",
        links: [
            { label: "NAMER (1:Few + Nvidia/Vanguard)", url: "#" },
            { label: "APAC (1:Few - cc Shatakshi)", url: "#" }
        ]
      },
      {
        id: "d3_jan",
        text: "Review Sales+SDR Presentation Deck",
        owner: "Ben + Marlee",
      }
    ]
};
